import { createFileRoute } from '@tanstack/react-router'

import PnsPppkPage from '@/components/pages/backoffice/_ktg-penyuluh/pns-pppk/containers/PnsPppkPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/pns-pppk/')({
  component: PnsPppkPage
})
